<template>
  <f-dashboard-content-layout :show-sidebar="false">
    <f-dashboard-content-wrapper :size="10">
      <div class="is-grid m-bottom-50">
        <div class="is-col-3">
          <stat-ingoing :year="annualStart.getFullYear()"></stat-ingoing>
        </div>

        <div class="is-col-3">
          <stat-ingoing 
            :from="annualStart" 
            :to="today"
          ></stat-ingoing>
        </div>

        <div class="is-col-3">
          <stat-ingoing 
            label="Trimestre"
            :from="trimestrialStart" 
            :to="trimestrialEnd"
          ></stat-ingoing>
        </div>

        <div class="is-col-3">
          <stat-ingoing 
            :year="annualStart.getFullYear()" 
            :month="today.getMonth()"
          ></stat-ingoing>
        </div>

        <div class="is-col-3">
          <stat-users-active
            label="Users actifs"
          ></stat-users-active>
        </div>

        <div class="is-col-3">
          <stat-users-active
            label="Abonnés actifs"
            users-type="paid"
          ></stat-users-active>
        </div>

        <div class="is-col-3">
          <stat-users-active
            label="Actifs sans abo"
            users-type="free"
          ></stat-users-active>
        </div>

        <div class="is-col-3">
          <stat-users-inactive
            label="Users inactifs"
          ></stat-users-inactive>
        </div>

        <div class="is-col-3">
          <donut-subscriptions></donut-subscriptions>
        </div>

        <div class="is-col-9">
          <chart-ca-users></chart-ca-users>
        </div>

        <div class="is-col-3">
          <stat-signup
            label="Nombre d'inscriptions"
          ></stat-signup>
        </div>

        <div class="is-col-3">
          <stat-signup
            label="Inscriptions du mois"
            :year="annualStart.getFullYear()" 
            :month="today.getMonth()"
            displayEvolution
          ></stat-signup>
        </div>

        <div class="is-col-3">
          <stat-removed
            label="Total suppressions"
          ></stat-removed>
        </div>

        <div class="is-col-3">
          <stat-removed
            label="Suppressions du mois"
            :year="annualStart.getFullYear()" 
            :month="today.getMonth()"
            displayEvolution
          ></stat-removed>
        </div>

        <div class="is-col-3">
          <stat-invoices-amount
            label="Montant total factures"
          ></stat-invoices-amount>
        </div>

        <div class="is-col-3">
          <stat-invoices-count
            label="Total factures"
          ></stat-invoices-count>
        </div>

        <div class="is-col-3">
          <stat-quotations-amount
            label="Montant total devis"
          ></stat-quotations-amount>
        </div>

        <div class="is-col-3">
          <stat-quotations-count
            label="Total devis"
          ></stat-quotations-count>
        </div>

        <div class="is-col-12">
          <chart-churn></chart-churn>
        </div>

        <div class="is-col-12">
          <chart-documents></chart-documents>
        </div>

        <div class="is-col-12">
          <chart-users-move></chart-users-move>
        </div>

        <div class="is-col-12">
          <chart-subscriptions
            type="paid"
          ></chart-subscriptions>
        </div>
        
      </div>
    </f-dashboard-content-wrapper>
  </f-dashboard-content-layout>
</template>

<script>
  import { computed, ref, reactive, toRefs } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import StatIngoing from '@components/statistics/stat-ingoing'
  import ChartCaUsers from '@components/statistics/chart-ca-users'
  import ChartSubscriptions from '@components/statistics/chart-subscriptions'
  import ChartDocuments from '@components/statistics/chart-documents'
  import ChartChurn from '@components/statistics/chart-churn'
  import ChartUsersMove from '@components/statistics/chart-users-move'
  import DonutSubscriptions from '@components/statistics/donut-subscriptions'
  import StatSignup from '@components/statistics/stat-signup'
  import StatRemoved from '@components/statistics/stat-removed'
  import StatPaidInactive from '@components/statistics/stat-paid-inactive'
  import StatUsersActive from '@components/statistics/stat-users-active'
  import StatUsersInactive from '@components/statistics/stat-users-inactive'
  import StatPaidSubscription from '@components/statistics/stat-paid-subscription'
  import StatFreeBegin from '@components/statistics/stat-free-begin'
  import StatInvoicesCount from '@components/statistics/stat-invoices-count'
  import StatInvoicesAmount from '@components/statistics/stat-invoices-amount'
  import StatQuotationsCount from '@components/statistics/stat-quotations-count'
  import StatQuotationsAmount from '@components/statistics/stat-quotations-amount'
  import useStatistics from '@composables/statistics/use-statistics.js'
  import useStates from '@composables/statistics/use-states.js'
  import dayjs from 'dayjs'
  
  export default {
    async setup() {
      const { fetch: fetchStates } = useStore('@admin/statistics/state')

      await fetchStates({
        query: {
          type: { $in: ['users', 'budget', 'billing'] }
        }
      })

      const today = new Date()
      const annualStart = dayjs().startOf('year').toDate()
      const trimestrialStart = dayjs().startOf('quarter').toDate()
      const trimestrialEnd = dayjs().endOf('quarter').toDate()

      return {
        today,
        annualStart,
        trimestrialStart,
        trimestrialEnd,
      }
    },

    components: {
      StatIngoing,
      ChartCaUsers,
      ChartSubscriptions,
      ChartDocuments,
      ChartChurn,
      ChartUsersMove,
      DonutSubscriptions,
      StatSignup,
      StatRemoved,
      StatPaidInactive,
      StatPaidSubscription,
      StatFreeBegin,
      StatInvoicesCount,
      StatInvoicesAmount,
      StatQuotationsCount,
      StatQuotationsAmount,
      StatUsersActive,
      StatUsersInactive,
    }
  }
</script>

